<template>
  <section class="stores">
    <div v-if="EPE_IF == 'CK' && request_list != ''" style="margin-bottom: 10px">
      <div style="background-color: white; padding: 30px; border-radius: 10px">
        <!-- <h1 style="font-size: 20px"></h1> -->
        <p class="P_XT" style="">审批详情</p>
        <!-- <p style="font-size: 14px">
        申请类型：{{approval_request_GetReason_text.approval_type == 'store'?
        '门店新增':approval_request_GetReason_text.approval_type == 'ClaimStore'?
        '门店认领':approval_request_GetReason_text.approval_type == 'store_edit'?
        '门店编辑':approval_request_GetReason_text.approval_type == 'store_astig'?
        '门店编辑':approval_request_GetReason_text.approval_type == 'store_try'?'门店编辑':''}} 申请人：{{ request_list_username }}
      </p> -->
        <el-steps :space="400" :active="num_zt" finish-status="success">
          <el-step
            v-for="(item, index) in request_list.ApprovalDataInfoList"
            :key="index"
            :status="item.adireason == '-1' ? 'error' : ''"
            :title="item.uername"
            :description="
              item.adireason == 0
                ? '(已审批)' + (item.date != null ? item.date : '')
                : item.adireason == 1
                ? '(未审批)' + (item.date != null ? item.date : '')
                : item.adireason == -1
                ? '(已驳回)' + (item.date != null ? item.date : '')
                : item.adireason == 2
                ? '(待审批)' + (item.date != null ? item.date : '')
                : ''
            "
          ></el-step>
        </el-steps>
        <!-- <div v-if="request_list.isadmin && SP_IF == 'SP'">
          <el-alert title="请在下方补充信息" style="margin-top: 20px" type="warning"></el-alert>
          <br />
          <div class="demo-input-suffix">
            <span style="color: red">*</span>
            ZCN 编号
            <el-input v-model="approval_request_Put_Material_list.data.BWAcctNumber" style="width: 250px" placeholder="请输入"></el-input>
          </div>
        </div> -->
        <el-alert
          v-if="description_text != ''"
          title="驳回理由"
          type="error"
          style="margin-top: 20px"
          :description="description_text"
          :closable="false"
          show-icon
        ></el-alert>
        <div v-if="SP_IF == 'SP'" style="margin-top: 20px; margin-bottom: 20px">
          <el-button type="success" @click="submit_approvals()">同 意</el-button>
          <el-button type="danger" @click="dialogVisible = true">驳 回</el-button>
        </div>
      </div>
    </div>
    <el-form ref="form" :model="form" :rules="editFormRules" label-width="180px" label-position="left">
      <div style="background-color: white; padding: 30px; border-radius: 10px">
        <p class="P_XT" style="">基本信息</p>
        <el-row>
          <el-col :span="7">
            <el-form-item label="Name">
              <el-input :disabled="true" v-model="form.Name" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="岗位号" prop="PostID">
              <el-select
                :disabled="(EM_IF == 'CK' && SP_IF != 'SP') || form.can_update == false"
                v-model="form.position_code"
                filterable
                remote
                :remote-method="crystal_position_code_chage"
                clearable
                collapse-tags
                placeholder="请输入"
                @change="crystal_position_change"
              >
                <el-option v-for="item in crystal_position_code_options" :label="item.Code" :value="item.Code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!--  <el-row>
          <el-col :span="7">
            <el-form-item label="事业部" prop="BU">
              <el-select :disabled="EM_IF == 'CK'" v-model="form.BU" placeholder="请选择">
                <el-option label="晶体事业部" value="晶体事业部"></el-option>
                <el-option label="飞秒激光及眼表事业部" value="飞秒激光及眼表事业部"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="转岗时间" prop="Reorientation_Date">
              <el-date-picker :disabled="EM_IF == 'CK'" v-model="form.Reorientation_Date" type="date" placeholder="请选择"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row> -->
        <!-- <el-row>
          <el-col :span="7">
            <el-form-item label="WWID">
              <el-input :disabled="true" v-model="form.WWID" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->

        <!-- <el-row>
          <el-col :span="7">
            <el-form-item label="岗位号">
              <el-input :disabled="true" v-model="form.position_code" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="7">
            <el-form-item label="原岗位号">
              <el-input :disabled="true" v-model="form.old_position_code" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="大区">
              <el-input :disabled="true" v-model="form.Level_3_string" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="原大区">
              <el-input :disabled="true" v-model="form.old_Level_3_string" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="小区">
              <el-input :disabled="true" v-model="form.Level_4_string" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="原小区">
              <el-input :disabled="true" v-model="form.old_Level_4_string" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="角色（一线销售/小区经理）">
              <el-input :disabled="true" v-model="form.role_name" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <br />
        <el-button @click="save('form')" v-if="EM_IF != 'CK'" v-preventReClick="3000" type="primary">保 存</el-button>
        <el-button @click="onBack()">返回</el-button>
      </div>
    </el-form>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <p style="margin: 0; padding: 0; padding-bottom: 10px">{{ form.msg }}</p>
      <el-input type="textarea" v-model="approval_request_Put_Material_list.reason"></el-input>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="turn_approvals()">确 定</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import util from '@/../util/date'
import {
  Employee_QueryById,
  Employee_Query_Claim_byid,
  HcoAddHCO,
  HcoUpdataHCO,
  approval_GetApprovalInfoByIDTag_Claim,
  HcoApproval,
  HcoHcoExportExcel,
  regionGetRegionTree,
  EmployeePosition_QueryList,
  EmployeeRegionGetEmployeeRegionTrees,
  //   EmployeePosition_QueryList,
  approval_request_Approval_Claim,
  EmployeeUpdateEmplovee,
  Employee_Position_Update,
} from '@/api/api'
import { getButtonList } from '@/promissionRouter'
import Toolbar from '@/components/Toolbar'

export default {
  components: { Toolbar },
  data() {
    return {
      EPE_IF: this.$route.query.type,
      Employee_list: [],
      Level_1: [],
      Level_2: [],
      city_list: [],
      region_list: [],
      fileList: [],
      crystal_position_code_options: [],
      approval_request_Put_Material_list: {
        approval_data_id: this.$route.query.approval_data_id,
        type: '已通过',
        state: 0,
        approvalstate: false,
        description: '',
      },
      dialogVisible: false,
      Sales_analytics_msg: false,
      request_list: [],
      description_text: '',
      rolename_if: false,
      num_zt: 0,
      EM_IF: this.$route.query.type,
      SP_IF: this.$route.query.status,
      token: {},
      form: {},
      editFormRules: {
        // PostID: [{ required: true, message: '请选择', trigger: 'blur' }],
        // Nane: [{ required: true, message: '请选择', trigger: 'blur' }],
        Level_0: [{ required: true, message: '请选择', trigger: 'blur' }],
        Level_1: [{ required: true, message: '请选择', trigger: 'blur' }],
        Level_2: [{ required: true, message: '请选择', trigger: 'blur' }],
        // BU: [{ required: true, message: "请选择", trigger: "blur" }],
        Level_3and4: [{ required: true, message: '请选择', trigger: 'blur' }],
      },
      SalesOperation_if: false,
      edit_if_2: false,
      edit_if: true,
      buttonList: [],
      managercode_list: [],
      currentRow: null,
      filters: {
        pageSize: 50,
      },
      users: [],
      statusList: [
        { LinkUrl: '激活', value: true },
        { LinkUrl: '禁用', value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
    }
  },
  methods: {
    crystal_position_change(e) {
      console.log(e)
      this.crystal_position_code_options.find((item) => {
        if (item.Code === this.form.PostID) {
          console.log(item)
          this.form.Level_3and4 = item.large_region_name + '/' + item.small_region_name
          this.form.Level_1 = item.Level_1
          this.form.Level_2 = item.Level_2
        }
      })
    },
    // Level_3and4Change (e) {
    //   this.form.Level_3 = e[0]
    //   this.form.Level_4 = e[1]
    //   console.log(e)
    // },
    // async submit_node(){
    //    const {data} = EmployeeUpdateEmplovee (this.form)
    //    if (data.success){
    //           this.$message({
    //             message:data.msg,
    //             type: "success",
    //           });
    //           this.dialogVisible= false
    //         } else{
    //           this.$message({
    //             message: data.msg,
    //             type: "error",
    //           });
    //         }

    // },
    btn_up_1(e) {
      window.open('/' + e)
    },
    async regionGetRegionTree_fn() {
      const { data } = await regionGetRegionTree()
      this.region_list = data.response
    },
    city_change(e) {
      this.city_list.find((item) => {
        if (item.name === e) {
          this.form.cityid = item.id
          // this.city_list = item.children
        }
      })
    },
    province_change(e) {
      var level_1_ = this.Level_1.find((item) => {
        return item.Name == e
      })
      if (level_1_) {
        this.Level_2 = level_1_.children
      }
    },
    async crystal_position_code_chage(e) {
      const { data } = await EmployeePosition_QueryList({
        code: e,
      })
      this.crystal_position_code_options = data.response
      console.log(this.HospitalName_options)
      console.log(data)
    },
    onBack() {
      this.$router.push(this.$route.query.back_url)
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => {})
    },

    // 审批接口
    async approval_request_Puts() {
      //   console.log(this.approval_request_Put_Material_list)
      this.approval_request_Put_Material_list.data = 'claim_position'
      var { data } = await approval_request_Approval_Claim(this.approval_request_Put_Material_list)
      //   HcoApproval(this.approval_request_Put_Material_list).then((res) => {
      console.log(data)
      if (data.status == 200) {
        this.$message({
          message: data.msg,
          type: 'success',
        })
        this.$router.push(this.$route.query.back_url)
        // this.dialogVisible =false
        // this.getDetails()
      } else {
        this.$message({
          message: data.msg,
          type: 'error',
        })
      }
    },
    turn_approvals() {
      this.approval_request_Put_Material_list.approvalstate = false
      this.approval_request_Puts()
    },
    Employee_Position_Update_fn() {
      const { data } = Employee_Position_Update({
        data_id: this.$route.query.id,
        position_code: this.form.position_code,
      })
    },
    submit_approvals() {
      this.approval_request_Put_Material_list.approvalstate = true
      console.log(this.form)
      this.$confirm(this.form.msg + '，确认同意？')
        .then((_) => {
          if (this.form.can_update) {
            if (!this.form.position_code) {
              this.$message({
                message: '请填写岗位号',
                type: 'warning',
              })
              return
            }
            this.Employee_Position_Update_fn()
          }
          this.approval_request_Puts()
        })
        .catch((_) => {})
    },
    // 审核进度
    async approval_request_Get(id) {
      let para_s = {}
      console.log(this.$route.query.claim_release)
      para_s = {
        approval_data_id: this.$route.query.approval_data_id,
        tag: 'claim_position',
      }
      var { data } = await approval_GetApprovalInfoByIDTag_Claim(para_s)
      //   approval_requestGetApprovalInfoByID(para_s).then((res) => {
      if (data.response) {
        let num_zt = 0
        for (var i in data.response.ApprovalDataInfoList) {
          if (data.response.ApprovalDataInfoList[i].adireason == 0) {
            num_zt++
          }
        }
        if (data.response.state == '-1') {
          this.description_text = data.response.reason
        }
        this.num_zt = num_zt
        this.request_list = data.response
        console.log(data.response.old_value)
        console.log(1)

        if (data.response.old_value) {
          // this.old_value = JSON.parse(data.response.old_value)
          if (data.response.state == -1) {
            this.old_value = data.response.new_value_data
            this.old_value_titile = '修改值'
          } else {
            this.old_value = data.response.old_value_data
            this.old_value_titile = '原值'
          }
          this.OLD_IF = true
          this.old_value.file_urls == null ? (this.old_value.file_urls = '') : ''
          if (this.old_value.file_urls) {
            this.file_urls_list = this.old_value.file_urls.split(',')
          }
          console.log(this.old_value)
        }
        //   this.form.BWAcctNumber = 888
        // if (data.response.isadmin) {
        //   this.approval_request_Put_Material_list.data.BWAcctNumber = this.form.BWAcctNumber
        // }
      }
      //   })
    },
    async save(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          var { data } = await EmployeeUpdateEmplovee(this.form)
          //   }
          if (data.status == 200) {
            this.$message({
              message: data.msg,
              type: 'success',
            })
            this.$router.push(this.$route.query.back_url)
          } else {
            this.$message({
              message: data.msg,
              type: 'error',
            })
          }
        } else {
          return
        }
      })
    },
    handlebefore() {
      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
    },
    handonerror() {
      console.log('超时失败')

      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      this.$message({
        message: '您的上传已超时，请再次尝试',
        type: 'error',
      })
      loading.close()
    },
    handleSuccess(file, fileLis) {
      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      if (file.success) {
        this.form.file_urls = file.response
        loading.close()
        this.$message({
          message: file.msg,
          type: 'success',
        })
        this.$refs.upload.clearFiles()
      } else {
        loading.close()
        this.$message({
          message: file.msg,
          type: 'error',
        })
        this.$refs.upload.clearFiles()
      }
    },
    ExportAccount() {
      let para = this.filters
      HcoHcoExportExcel(para).then((res) => {
        window.location.href = res.data.msg
      })
    },
    selectCurrentRow(val) {
      this.currentRow = val
    },
    callFunc(item) {
      this[item.Func].apply(this, item)
    },
    //获取用户列表
    getDetails() {
      console.log(this.$route.query.id)
      Employee_Query_Claim_byid({ id: this.$route.query.id }).then((res) => {
        this.form = res.data.response
        this.province_change()
        this.form.Level_3and4 = this.form.Level_3 + '/' + this.form.Level_4
      })
    },
    selsChange: function (sels) {
      this.sels = sels
    },
    async EmployeeRegionGetEmployeeRegionTrees_fn() {
      const { data } = await EmployeeRegionGetEmployeeRegionTrees()
      this.Level_1 = data.response
    },
  },
  mounted() {
    let tokenStr = window.localStorage.Token
    this.token = {
      Authorization: 'Bearer ' + tokenStr,
    }
    this.regionGetRegionTree_fn()
    this.EmployeeRegionGetEmployeeRegionTrees_fn()
    if (this.$route.query.type != 'ADD') {
      this.getDetails()
    }
    if (this.$route.query.type == 'CK') {
      this.approval_request_Get(this.$route.query.id)
    }
    // this.EmployeeRegionGetEmployeeRegionTrees_fn()
  },
}
</script>

<style scoped>
.demo-input-suffix {
  display: inline-block;
  margin-right: 15px;
}
.demo-input-suffix > .el-input {
  width: 150px;
  margin-bottom: 20px;
}
.stores >>> .el-select,
.stores >>> .el-date-editor {
  width: 100%;
}
.el-form-item__error {
  top: 19% !important;
  right: -29% !important;
}
</style>
